import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Ninja } from 'src/app/Classes/schema';
import { AnwService } from 'src/app/Services/ANW/anw.service';

@Component({
  selector: 'app-new-ninja',
  templateUrl: './new-ninja.component.html',
  styleUrls: ['./new-ninja.component.css']
})
export class NewNinjaComponent implements OnInit {
  ninja: Ninja;
  constructor(
    private anw: AnwService,
    private dialogRef: MatDialogRef<NewNinjaComponent>,
    @Inject(MAT_DIALOG_DATA) public ninjaData: { name: any }
  ) { }

  ngOnInit() {
    this.ninja = new Ninja();
    console.log(this.ninjaData.name);
    this.ninja.name = this.ninjaData.name;
  }

  saveButtonHandler() {
    const fhs = this.anw.fhs;
    fhs.writeDoc('ninjas', this.ninja, this.ninja.id());
    this.dialogRef.close(this.ninja);
  }
}
